import React from 'react'

const Footer = () => {
    return (
        <>
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-10 mx-auto">
                            <div className="row">
                                <div className="col-6 col-lg-3">
                                    <h2>Company</h2>
                                    <ul>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <h2>Support</h2>
                                    <ul>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <h2>Services</h2>
                                    <ul>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                        <li>
                                            <a href='#'>About</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <h2>Follow us</h2>
                                    <div className='row'>
                                        <div className='col-3 mx-auto'>
                                            <a href="https://instagram.com/Prmd96">
                                                <i class='fab fa-instagram fontawesome-style'></i>
                                            </a>
                                        </div>
                                        <div className='col-3 mx-auto'>
                                            <a href="https://twitter.com/Prmd96">
                                                <i class='fab fa-facebook fontawesome-style'></i>
                                            </a>
                                        </div>
                                        <div className='col-3 mx-auto'>
                                            <a href="https://www.linkedin.com/in/pramodsuthar/">
                                                <i class='fab fa-linkedin fontawesome-style'></i>
                                            </a>
                                        </div>
                                        <div className='col-3 mx-auto'>
                                            <a href="https://github.com/PramodSuthar">
                                                <i class='fab fa-github fontawesome-style'></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <hr />
                            <div className='mt-5'>
                                <p className='main-hero-para text-center w-100'>Copyright ©2021 FlexiPay. All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
